import { Expose, Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { Campaign } from "../../entity";

export class ModifyCampaignDTO {
  @Expose()
  @ValidateNested()
  @Type(() => Campaign)
  campaign!: Campaign;
}
